<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<!-- Toolbar -->
<div class="toolbar" role="banner">
    <!--<h3>{{title}}</h3>-->
    <img src="./../assets/img/WausaUltra Logo Color WEBHead.png" style="height:50px;" />
    <img src="./../assets/img/FinalBackYard_TransparentBlack.png" style="height:50px;" />
    <div class="spacer"></div>
    <!-- switcher nav in here for the different components -->
    <ul class="top-nav">
        <!-- todo: add in a marker for which link is active -->
        <li class="nav-link"><a href="/racers"><span>Racers</span></a></li>
        <li class="nav-link"><a href="/tracking"><span>Leaderboard</span></a></li>
        <li class="nav-link"><a href="/timing" *ngIf="dataService.appMode == 'manager'"><span>Timing</span></a></li>
    </ul>
</div>

<div class="content" role="main">

  <!-- placeholder for future information -->

</div>


<router-outlet></router-outlet>